import { User, Building2 } from "lucide-react";

/**
 * Toggle buttons for selecting contact type (Individual/Organisation)
 */
const ContactTypeSelector = ({ contactType, setContactType }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-8">
      <button
        type="button"
        onClick={() => setContactType("individual")}
        data-testid="toggle-individual"
        className={`flex-1 flex items-center justify-center gap-3 py-4 px-4 sm:px-6 border transition-all ${
          contactType === "individual"
            ? "bg-[#56C6C6]/10 border-[#56C6C6] text-[#56C6C6]"
            : "bg-transparent border-white/10 text-zinc-400 hover:border-white/20"
        }`}
      >
        <User className="w-5 h-5 flex-shrink-0" />
        <span className="font-semibold uppercase tracking-wider text-sm">Individual</span>
      </button>
      <button
        type="button"
        onClick={() => setContactType("organization")}
        data-testid="toggle-organization"
        className={`flex-1 flex items-center justify-center gap-3 py-4 px-4 sm:px-6 border transition-all ${
          contactType === "organization"
            ? "bg-[#56C6C6]/10 border-[#56C6C6] text-[#56C6C6]"
            : "bg-transparent border-white/10 text-zinc-400 hover:border-white/20"
        }`}
      >
        <Building2 className="w-5 h-5 flex-shrink-0" />
        <span className="font-semibold uppercase tracking-wider text-sm">Organisation</span>
      </button>
    </div>
  );
};

export default ContactTypeSelector;
